(function() {
  'use strict';
  function JobList (container) {
    this.form = container.querySelector("[data-type='lns-jobs-filter-form']");
    this.list = container.querySelector("[data-type='showmore']");
    this.items = this.list.querySelectorAll('[data-type="filter-item"]');
    this.items = Array.prototype.slice.call(this.items, 0);
    this.showmore = this.list.querySelector("[data-type='showmore-trigger']");
    this.formBubbles = container.querySelector("[data-type='lns-jobs-filter-bubbles']");
    // try to find a unique storage identifier
    this.store = null;
    let params = new URLSearchParams(window.location.search);
    function findClosest(el, s) {
      let dest = null;
      do {
        dest = el.querySelector(s);
        if (dest) return dest;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    }
    // generate store name
    this.store = window.location.pathname;
    let id = this.list.id;
    if (id) {
      this.store = this.store + '/' + id;
    }
    let t, tab = findClosest(this.list, 'ul.tabsheets > li.tabsheet-item > .sheet-header');
    if (tab) {
      t = tab.innerHTML;
      this.store = this.store + '/#' + t;
    }
    let q = params.get("tx_solr[q]");
    if (q) {
      this.store = this.store + '/' + q;
    }
    this.step = 0;
    this.count = 0;
    this.location = 'all';
    this.company = '0';
    this.education = '';
    this.query = '';
    this.filterLocation = this.form.querySelector('[data-type="lns-jobs-filter-location"]');
    this.filterCompany = this.form.querySelector('[data-type="lns-jobs-filter-company"]');
    this.filterEducation = this.form.querySelector('[data-type="lns-jobs-filter-education"]');
    this.filterQuery = this.form.querySelector('[data-type="lns-jobs-filter-query"]');
    this.filterReset = this.form.querySelector('[data-type="lns-jobs-filter-reset"]');
    // implementation of deep link
    let hash = window.location.hash;
    if (hash) {
      let str = decodeURI(hash.substring(1));
      let arr = str.split('-')
      if (arr.length === 3) {
        this.location = (arr[0] && ((arr[0] === 'Geldern') || (arr[0] === 'Köln')) ? arr[0] : 'all');
        this.company = (arr[1] && parseInt(arr[1], 10) < 3 ? arr[1] : '0');
        this.education = (arr[2] && arr[2] === 'Ausbildung' ? arr[2] : '');
        this.setSessionStorageValues();
      }
    }
    this.init();
  }
  JobList.prototype = {
    getSessionStorageValues: function () {
      let configJSON = sessionStorage.getItem('jobfilter-' + this.store);
      let config = JSON.parse(configJSON);
      if (config) {
        if (this.filterLocation) {
          this.location = config.location;
          this.filterLocation.value = config.location;
        }
        if (this.filterCompany) {
          this.company = config.company;
          this.filterCompany.value = config.company;
        }
        if (this.filterEducation) {
          this.education = config.education;
          this.filterEducation.checked = (this.education !== '');
        }
        if (this.filterQuery) {
          this.query = config.query;
          this.filterQuery.value = config.query;
        }
      }
    },
    setSessionStorageValues: function () {
      let config = {
        'location': this.location,
        'company': this.company,
        'education': this.education,
        'query': this.query
      };
      let configJSON = JSON.stringify(config);
      sessionStorage.setItem('jobfilter-' + this.store, configJSON);
    },
    reset: function (el) {
      if (el) {
        switch (el.id) {
          case 'company':
            this.company = '0';
            break;
          case 'location':
            this.location = 'all';
            break;
          case 'education':
            this.education = '';
            break;
        }
      } else {
        this.location = 'all';
        this.company = '0';
        this.education = '';
        this.query = '';
      }
      this.setSessionStorageValues();
      this.getSessionStorageValues();
      this.filter();
    },
    setLocation: function (value) {
      this.location = value;
      this.filter();
      this.setSessionStorageValues();
    },
    setCompany: function (value) {
      this.company = value;
      this.filter();
      this.setSessionStorageValues();
    },
    setEducation: function (value) {
      this.education = value;
      this.filter();
      this.setSessionStorageValues();
    },
    setQuery: function (value) {
      this.query = value;
      this.filter();
      this.setSessionStorageValues();
    },
    matchLocation: function (item) {
      if (!this.filterLocation || (this.location === 'all')) {
        return true;
      }
      if (item.getAttribute('data-filter-location')) {
        let location = item.getAttribute('data-filter-location').split(' ');
        return (location.indexOf(this.location) !== -1);
      }
      return false;
    },
    matchCompany: function (item) {
      if (!this.filterCompany || (this.company === '0')) {
        return true;
      }
      if (item.getAttribute('data-filter-company')) {
        let company = item.getAttribute('data-filter-company');
        return (company === this.company);
      }
      return false;
    },
    matchEducation: function (item) {
      if (!this.filterEducation || (this.education === '')) {
        return true;
      }
      let education = item.getAttribute('data-filter-education');
      return (education === this.education);
    },
    matchQuery: function (item) {
      if (!this.filterQuery || (this.query === '')) {
        return true;
      }
      let txt = item.innerText;
      return (txt.toLowerCase().indexOf(this.query.toLowerCase()) !== -1);
    },
    filter: function () {
      this.removeFormBubbles();
      let count = 0;
      if (sessionStorage.getItem('showmore-' + this.store)) {
        this.step = sessionStorage.getItem('showmore-' + this.store);
      } else {
        this.step = this.list ? parseInt(this.list.dataset.step, 10) : 6;
      }
      for (let i = 0; i < this.items.length; i++) {
        if (this.matchLocation(this.items[i]) &&
          this.matchCompany(this.items[i]) &&
          this.matchEducation(this.items[i]) &&
          this.matchQuery(this.items[i])) {
          this.items[i].style.display = '';
          if (this.step > count) {
            this.items[i].classList.remove('hidden');
          } else {
            this.items[i].classList.add('hidden');
          }
          count++;
        } else {
          this.items[i].style.display = 'none';
          this.items[i].classList.remove('hidden');
        }
      }
      if (count > this.step) {
        this.showmore.classList.remove('hidden');
      } else {
        this.showmore.classList.add('hidden');
      }
      this.updateFormBubbles();
    },
    getBubbleLabel: function (element, value) {
      const elementId = element.id;
      const elementLabel = this.form.querySelector('label[for="' + elementId + '"]');
      if (null === elementLabel) {
        return null;
      }
      let bubbleLabel = elementLabel.textContent.trim() + ': ';
      if ('checkbox' === element.type) {
        bubbleLabel = bubbleLabel.replace(': ', '');
      }
      return bubbleLabel + value;
    },
    isSelectField: function (element) {
      return 'select-one' === element.type
    },
    isCheckbox: function (element) {
      return 'radio' === element.type
        || 'checkbox' === element.type;
    },
    isActiveCheckbox: function (element) {
      return true === element.checked;
    },
    createBubbleElement: function (label) {
      const bubbleElement = document.createElement('div');
      const bubbleLabelNode = document.createTextNode(label);
      bubbleElement.setAttribute('type', 'button');
      bubbleElement.setAttribute('tabindex', '0');
      bubbleElement.classList.add('lns-filter-bubble');
      bubbleElement.appendChild(bubbleLabelNode);
      const bubbleClose = document.createElement('div');
      bubbleClose.classList.add('lns-filter-bubble-close');
      bubbleElement.appendChild(bubbleClose);
      return bubbleElement;
    },
    addBubble: function (element, value) {
      const bubbleLabel = this.getBubbleLabel(element, value);
      if (null === bubbleLabel) {
        return;
      }
      const bubble = this.createBubbleElement(bubbleLabel);
      this.formBubbles.appendChild(bubble);
      bubble.addEventListener(
        'click',
        () => this.reset(element),
        false
      );
      bubble.addEventListener(
        'keydown',
        (event) => {
          if (event.keyCode === 32) {
            event.preventDefault();
            event.target.click();
          }
        },
        false
      );
    },
    removeFormBubbles: function () {
      while (this.formBubbles.firstChild) {
        this.formBubbles.removeChild(this.formBubbles.firstChild);
      }
    },
    addFormBubble: function (element) {
      const elementValue = element.value;
      if (true === this.isCheckbox(element)) {
        if (true === this.isActiveCheckbox(element)) {
          this.addBubble(element, '')
        }
        return;
      }
      if (true === this.isSelectField(element)) {
        if (('' !== elementValue) && ('0' !== elementValue) && ('all' !== elementValue)) {
          const selectedLabel = element.options[element.selectedIndex].text;
          this.addBubble(element, selectedLabel);
        }
        return;
      }
      if ('' !== elementValue) {
        this.addBubble(element, ' ' + elementValue);
      }
    },
    updateFormBubbles: function () {
      const formElements = this.form.querySelectorAll('input, select');
      formElements.forEach(element => {
        this.addFormBubble(element)
      });
    },
    init: function() {
      const self = this;
      if (this.filterReset) {
        this.filterReset.addEventListener('click', function() {
          self.reset();
        });
      }
      this.updateFormBubbles();
      if (this.filterLocation) {
        this.filterLocation.addEventListener('change', function () {
          self.setLocation(this.options[this.selectedIndex].value);
        });
      }
      if (this.filterCompany) {
        this.filterCompany.addEventListener('change', function () {
          self.setCompany(this.options[this.selectedIndex].value);
        });
      }
      if (this.filterEducation) {
        this.filterEducation.addEventListener('change', function () {
          self.setEducation(this.checked ? this.value : '');
        });
      }
      if (this.filterQuery) {
        let timeout;
        const searchWait = function (e) {
          clearTimeout(timeout);
          let search = e.target.value;
          timeout = setTimeout(function () {
            self.setQuery(search);
          }, 500);
        };
        this.filterQuery.addEventListener('keyup', searchWait);
        this.filterQuery.addEventListener('input', searchWait);
      }
      this.getSessionStorageValues();
      this.filter();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    /** @type {NodeListOf<Element>} */
    let containers = document.querySelectorAll('[data-type="lns-jobs-filter-wrap"]');
    for (let i = 0; i < containers.length; i++) {
      new JobList(containers[i]);
    }
  })
})();
